import(/* webpackMode: "eager" */ "/app/src/app/[lng]/(use-auth)/providers/page.tsx");
